module.exports = __webpack_public_path__ + "img/logo3.c0580990.png";